import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import style from '../boxContent/BoxContent.module.scss'
import { fetchTrendMovies } from '../../../redux/contentSlices/asyncActions'
import { setFetching } from '../../../redux/contentSlices/ContentSlices';
import HoverBlock from '../boxContent/hoverBlock/HoverBlock';
import SkeletonContent from '../../preloader/SceletonContent';
import { selectContent } from '../../../redux/contentSlices/ContentSelector'
import { NavLink } from 'react-router-dom';
import { selectHeader } from '../../../redux/headerSlices/HeaderSelector'
import { useAppDispatch } from '../../../redux/Store';


type Content = {
    large_cover_image: string;
    title: string;
    id: number;
    year: number;
    rating: number;
    mpa_rating: number;
    runtime: number;
    genres: string[];
}

let Trends = () => {

    const dispatch = useAppDispatch();

    const { trendPage, totalCount, content, status, fetching } = useSelector(selectContent)

    const { search } = useSelector(selectHeader)

    useEffect(() => {
        if (fetching) {
            try {
                dispatch(fetchTrendMovies({ trendPage, search }))
            } catch {
                alert('An error has occurred, the start page will be loaded')
            }
        }
    }, [fetching]);

    useEffect(() => {
        document.addEventListener('scroll', ScrollHandler)
        return function () {
            document.removeEventListener('scroll', ScrollHandler)
        }
    }, [totalCount])


    const ScrollHandler = (e: any) => {
        if (e.target.documentElement.scrollHeight - (e.target.documentElement.scrollTop + window.innerHeight) < 100 && content.length < totalCount) (
            dispatch(setFetching(true))
        )
    }
    const Skeleton = [...new Array(24)].map((el) => <SkeletonContent />)

    return (
        <div className={style.Box__content}>
            {status === 'completed' ? content.map((el: Content) =>
                <div className={style.content__block} data-testid='movie'>
                    <HoverBlock id={el.id} rating={el.rating} mpa_rating={el.mpa_rating} runtime={el.runtime} genres={el.genres} />
                    <img src={el.large_cover_image} className={style.movie__img} alt='The image is missing' />
                    <div className={style.movie__info}>
                        <NavLink to={`/movieDetails/${el.id}`} ><span className={style.info__title}>{el.title}</span></NavLink >
                        <span className={style.info__subtitle}>{el.year}</span>
                    </div>
                </div>
            ) : Skeleton}
        </div>
    )
}

export default Trends;

